export default __webpack_public_path__ + "static/SwiftDoc-privacy-statement-758d68aaeb676059546e811c864b0d44.pdf";